import styled from 'styled-components';

const HeaderWrapper = styled.div`
	position: relative;
	align-self: center;
	display: flex;
	justify-self: end;
	align-items: center;
`;

const PageHeadRightSideWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
	${props => (props.isInGame ? 'flex: 1; justify-content: flex-end;' : '')};
`;

const PageHeadRightSide = ({ children, isInGame }) => {
	return (
		<PageHeadRightSideWrapper data-at="rightside-layout-header" isInGame={isInGame}>
			<HeaderWrapper>{children}</HeaderWrapper>
		</PageHeadRightSideWrapper>
	);
};

export default PageHeadRightSide;
